


















































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../general/OnscreenMenu.vue";
import CategoryTypeSelect from "../general/CategoryTypeSelect.vue";
import EventsEventDetails from "../events/EventsEventDetails.vue";

import EventJson, { getEventStatus, getDuplicateEventJson } from "../../shared/EventJson";
import { EventStatus, EventStatusNames } from "../../shared/EventStatus";

import SettingsJson from "../../shared/SettingsJson";
import CategoryTypeJson from "../../shared/CategoryTypeJson";
import { CategoryTypeType } from "../../shared/CategoryTypeType";
import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "EventsEvents",
  components: {
    Loading,
    TableView,
    OnscreenMenu,
    CategoryTypeSelect,
    EventsEventDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      EventStatus: EventStatus,
      EventStatusNames: EventStatusNames,
      CategoryTypeType: CategoryTypeType,
      showDetails: false,
      detailsMode: "read",
      categoryTypes: null as CategoryTypeJson[] | null,
      showNotScheduled: false as boolean,
      useFilters: false as boolean,
      filterStates: [] as EventStatus[],
      filterOnlyUpcoming: false as boolean,
      filterOnlyRegistrationAllowed: false as boolean,
      filterOnlyInternal: false as boolean,
      filterRestrictToTypes: [] as CategoryTypeJson[],
      searchString: null as string | null,
      allEvents: null as EventJson[] | null,
      eventsMoreAvailable: null as boolean | null,
      selectedEventId: null as number | null,
      selectedEvent: null as EventJson | null,
      showOldEvents: false as boolean,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.loadData();
      }
    },

    loadData() {
      this.loadAllEvents();
      this.loadCategoryTypes();
    },

    async loadAllEvents(loadMore: null = null) {
      //show loading on search or remove search
      if (this.searchString !== null) {
        if (loadMore == null) {
          this.allEvents = null;
        }
        if (this.searchString == "") {
          this.searchString = null;
        }
      }

      var states = null as EventStatus[] | null;
      var onlyUpcoming = false;
      var onlyRegistrationAllowed = false;
      var onlyInternal = false;
      var restrictToTypeIds = [] as number[];
      var skipAmount = null as number | null;

      //filters
      if (this.useFilters) {
        this.filterStates.length > 0 ? (states = this.filterStates) : (states = null);
        onlyUpcoming = this.filterOnlyUpcoming;
        onlyRegistrationAllowed = this.filterOnlyRegistrationAllowed;
        onlyInternal = this.filterOnlyInternal;
        if (this.filterRestrictToTypes.length > 0)
          restrictToTypeIds = this.filterRestrictToTypes.map((i: CategoryTypeJson) => i.ID!);
      }

      //load more
      if (loadMore && this.allEvents != null) {
        this.eventsMoreAvailable = null;
        skipAmount = this.allEvents.length;
      } else {
        this.allEvents = null;
      }

      if (this.restClient != null) {
        try {
          let events = await this.restClient.getEvents(
            states,
            onlyUpcoming,
            onlyRegistrationAllowed,
            onlyInternal,
            restrictToTypeIds,
            null,
            null,
            this.searchString,
            this.showNotScheduled,
            skipAmount
          );

          if (loadMore && this.allEvents != null) {
            this.allEvents = this.allEvents.concat(events.events);
          } else {
            this.allEvents = events.events;
          }

          this.eventsMoreAvailable = events.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadCategoryTypes() {
      this.categoryTypes = null;

      try {
        this.categoryTypes = await this.restClient.getCategoryTypes();
      } catch (e) {
        alert(e.message);
      }
    },

    reloadData() {
      this.loadAllEvents();
    },

    applyUseFilters() {
      this.useFilters = true;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();

      this.loadAllEvents();
    },

    removeUseFilters() {
      this.useFilters = false;

      this.filterStates = [];
      this.filterOnlyUpcoming = false;
      this.filterOnlyRegistrationAllowed = false;
      this.filterOnlyInternal = false;
      this.filterRestrictToTypes = [];
      (this.$refs.filterMenu as any).toggleOnscreenMenu();

      this.loadAllEvents();
    },

    resetSearchString() {
      this.searchString = "";

      this.loadAllEvents();
    },

    openDetails(item: EventJson | null, mode: string) {
      if (item != null) {
        this.selectedEventId = item.ID;
        this.selectedEvent = JSON.parse(JSON.stringify(item));
      } else {
        this.selectedEventId = null;
        this.selectedEvent = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },

    async duplicateEvent(item: EventJson) {
      let newItem: EventJson = getDuplicateEventJson(item);

      this.allEvents = null;

      try {
        let duplicatedEvent = await this.restClient.addEvent(newItem);
      } catch (e) {
        alert(e.message);
      }

      this.loadAllEvents();
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }

      if (button == "duplicateEvent") {
        this.duplicateEvent(item);
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },

    showNotScheduled: function () {
      this.reloadData();
    },
  },
  computed: {
    filteredEvents(): EventJson[] | null {
      if (this.allEvents != null && !this.showOldEvents) {
        let today = new Date();
        let filtered = this.allEvents.filter((i: any) =>
          i.dates ? new Date(i.dates[i.dates.length - 1].endDateTime) > today : true
        );

        return filtered;
      } else {
        return this.allEvents;
      }
    },

    eventColumns: function (): TableViewColumnDefinitions<EventJson>[] {
      let vue = this;

      return [
        {
          th: "Verwanstaltung",
          td: (i) => i.title,
        },
        {
          th: "Erster Termin",
          td: (i) =>
            i.dates ? DateFormatter.formatWeekdayDateTimeLong(new Date(i.dates[0].beginDateTime)) : "Individuell",
        },
        {
          th: "Letzter Termin",
          td: (i) =>
            i.dates
              ? DateFormatter.formatDateMedium(new Date(i.dates[i.dates.length - 1].beginDateTime))
              : "Individuell",
        },
        {
          th: "Status",
          td: (i) => getEventStatus(i).text,
        },
        {
          th: "",
          td: (i) => "Bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
        {
          th: "",
          td: (i) => "Duplizieren",
          style: (i) => "text-align:right",
          button: "duplicateEvent",
        },
      ] as TableViewColumnDefinitions<EventJson>[];
    },
  },
});
